/**
 * Generated runtime TestId mirror for frontend/src/components/form-layout/designer/FieldProperties.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FieldPropertiesTestIds = {
  colSpanCustomBtn: "col-span-custom-btn",
  colSpanCustomInput: "col-span-custom-input",
  fieldDefaultInput: "field-default-input",
  fieldLabelInput: "field-label-input",
  fieldPlaceholderInput: "field-placeholder-input",
  fieldTemplateInput: "field-template-input",
  visibilityFieldKeySelect: "visibility-field-key-select",
  colSpanPreset: (preset_value: string) => `col-span-preset-${preset_value}`,
  colSpanPresetPrefix: () => "col-span-preset-" as TestIdPrefix,
  requiredOverride: (opt: string) => `required-override-${opt}`,
  requiredOverridePrefix: () => "required-override-" as TestIdPrefix
} as const;
